import { useMutation } from '@tanstack/react-query';
import { createLead, ICreateLeadPayload } from '@Services/init/welcome.api.ts';
import { CustomerData, useBoundStore } from '@Store/index.ts';
import { updateCustomerDataFromServer } from '@Services/init/util.ts';

export const useCreateLead = () => {
  const customerData = useBoundStore((state) => state.customer);
  const setCustomerData = useBoundStore((state) => state.setCustomerData);

  return useMutation({
    mutationFn: (props: ICreateLeadPayload) => createLead({ ...props }),
    onSuccess: (data) => {
      const updatedCustomerData = { ...customerData, ...data, customerId: data?.externalId };
      setCustomerData(updatedCustomerData);
      updateCustomerDataFromServer(data as Partial<CustomerData>, updatedCustomerData);

      if (data?.isPartner) {
        // Modify navigation stack for partners / Vice versa
      }
      if (data?.moreData) {
        //
      } else if (data?.requireAuthentication) {
        // @TODO move to login screen
      }
    },
  });
};
